module.exports = __webpack_public_path__ + "img/info_msg.50296900.png";